import * as React from 'react';
import clsx from 'clsx';

import './style.scss';

export interface IPreloaderProps extends React.HTMLProps<HTMLDivElement> {
    width?: number;
    height?: number;
}

export const Preloader = React.forwardRef<HTMLDivElement, IPreloaderProps>(
    ({
        className,
        width = 40,
        height = 40,
        style,
        ...restDivProps
    }, ref) => (
        <div
            className={clsx('preloader', className)}
            style={{
                width,
                height,
                ...style
            }}
            ref={ref}
            {...restDivProps}
        >
            <div />
            <div />
            <div />
            <div />
        </div>
    )
);
